import { render, staticRenderFns } from "./AlBreadcrumbItem.vue?vue&type=template&id=af0c2edc&"
import script from "./AlBreadcrumbItem.vue?vue&type=script&lang=js&"
export * from "./AlBreadcrumbItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports